import { Box, Typography } from "@mui/material"
import type { FC } from "react"
import { useMemo } from "react"

import { FilterChip } from "@/components/common/Filters"
import type { Option } from "@/types/form-fields"

interface GoodsReceiptFilterChipsProps {
  warehouseAreaIds: string[]
  warehouseOptions: Option<string>[]
  onRemove: (warehouseId: string) => void
}

export const GoodsReceiptFilterChips: FC<GoodsReceiptFilterChipsProps> = ({
  warehouseAreaIds,
  warehouseOptions,
  onRemove,
}) => {
  const warehouseLabelsMap = useMemo(() => {
    return new Map(warehouseOptions.map((option) => [option.value, option.label]))
  }, [warehouseOptions])

  if (warehouseOptions.length === 0 || warehouseAreaIds.length === 0) {
    return null
  }

  return (
    <Box className='flex flex-wrap items-center gap-2' data-testid='filter-chips'>
      <Typography variant='body1' className='text-gray-700'>
        Applied filters:
      </Typography>
      {warehouseAreaIds.map((warehouseAreaId) => {
        const label = warehouseLabelsMap.get(warehouseAreaId)

        if (!label) return null

        return (
          <FilterChip
            key={warehouseAreaId}
            label={`Warehouse: ${label}`}
            onDelete={() => onRemove(warehouseAreaId)}
            testId={`warehouse-chip-${warehouseAreaId}`}
          />
        )
      })}
    </Box>
  )
}
